import _color from '@/assets/utils/color.js';
<template>
  <div
    class="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
  >
    <vx-card>
      <div class="vx-row mt-2" v-if="acstate == 'EDIT'">
        <div class="vx-col mt-3" style="width: 200px; text-align: right">
          <span>Number</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-input
            class="w-3/5"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="number"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 mt-6" v-if="acstate == 'ADD'">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>Inbound Number</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="inbordersNumber"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                  @click="searchInb"
                  >ดึงข้อมูล Inbound</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Consignee Code</span>
        </div>
        <div class="vx-col mt-5 sm:w-1/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="businessPartnersCode"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Consignee Name</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="ename"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 190px; text-align: right">
          <span>Arrival Date</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <div class="column is-narrow -mt-2">
            <div style="width: 200px">
              <flat-pickr
                :config="configdateTimePicker"
                disabled="disabled"
                v-model="dcldate"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>HAWB</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="hawb"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>MAWB</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="mawb"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Description</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="edescription"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Package</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="itempck"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Unit</span>
        </div>
        <div class="vx-col mt-5 sm:w-1/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="packagesCode"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>G/W</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="itemgw"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Unit</span>
        </div>
        <div class="vx-col mt-5 sm:w-1/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="gwunit"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Remark</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="remark"
          />
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Status</span>
        </div>
        <div class="vx-col mt-5 sm:w-1/4 w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="status"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row mt-8">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSubmit">Submit</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vs-popup fullscreen title="Invoice Number" :active.sync="popupActive6">
      <inbound
        v-if="popupActive6"
        :companyGroupsCode="companyGroupsCode"
        @recsel="recsel"
      ></inbound>
    </vs-popup>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import inbound from "./inbdetailsgrid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      skus_code:"",
      number: "",
      dcldate: "",
      vesselname: "",
      inbordersNumber: "",
      companyGroupsCode: "",
      businessPartnersCode: "",
      packagesCode: "",
      gwunit: "",
      ename: "",
      customers: [],
      itempck: 0,
      itemgw: 0,
      mawb: "",
      hawb: "",
      payments: [
        { code: "CASH", name: "CASH" },
        { code: "TRANSFER", name: "TRANSFER" },
        { code: "CHEQUE", name: "CHEQUE" },
      ],
      remark: "",
      status: "",
      edescription: "",
      readonly: false,
      popupActive6: false,
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
    };
  },
  validations: {
    inbordersNumber: {
      required,
    },
  },
  components: {
    inbound,
  },
  props: ["acstate", "recid"],
  methods: {
    searchInb() {
      // console.log("inb");
      this.popupActive6 = true;
    },
    async recsel(val,val2) {
      this.skus_code = val;
      this.inbordersNumber = val2;
      // console.log(this.inbordersNumber);
      // console.log(val);

      this.popupActive6 = false;

      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Confirm`,
        text: "ยืนยันการสร้างรายการจาก Inbound? ",
        accept: this.acceptCharge,
      });
    },
    async acceptCharge() {
      // alert(this.inbordersNumber)

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (this.inbordersNumber == "") {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      }

      const formData = {
        skus_code: this.skus_code,
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/dlvorders/getInbound`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)
// 
          if (!response.data) {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: "Error From Backend",
            });
          } else {
            this.businessPartnersCode = response.data.inbound[0].businessPartnersCode;
            this.ename = response.data.inbound[0].ename;
            this.dcldate = response.data.inbound[0].dcldate;
            this.inbordersNumber = response.data.inbound[0].number;
            this.vesselname = response.data.inbound[0].vesselname;
            this.mawb = response.data.inbound[0].mawb;
            this.hawb = response.data.inbound[0].hawb;
            this.packagesCode = response.data.inbound[0].packagesCode;
            this.gwunit = response.data.inbound[0].gwunit;
            this.edescription = response.data.inbound[0].edescription;
            this.itemgw = response.data.itemgw[0].itemgw;
            this.itempck = response.data.itempck[0].itempck;
            this.remark = response.data.inbound[0].remark;
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    clsd: function () {
      this.remark = "";
      let vm = this;

      vm.$emit("grid");
    },
    async onSubmit() {
      // alert("Hi");
      let vm = this;

      if (this.status == "PRINTED") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Status PRINTED ไม่สามารถแก้ไขได้",
          text: "Please check the Status",
          fixed: true,
        });
        return;
      }

      const formData = {
        acstate: this.acstate,
        ename: this.ename,
        number: this.recid,
        businessPartnersCode: this.businessPartnersCode,
        dcldate: this.dcldate,
        inbordersNumber: this.inbordersNumber,
        vesselname: this.vesselname,
        mawb: this.mawb,
        hawb: this.hawb,
        edescription: this.edescription,
        itemgw: this.itemgw,
        itempck: this.itempck,
        remark: this.remark,
        packagesCode: this.packagesCode,
        gwunit: this.gwunit,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/dlvorders/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
            vm.clsd();
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }

      // vm.$emit("grid");
      // vm.clsd();
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          // console.log(decoded);
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
  },
  async created() {
    // console.log(this.recid);
    // console.log("create");
    this.checkProfiles();

    if (this.recid != "0") {
      // alert("Edit");
      try {
        this.readonly = true;
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.get(
          `${BASE_API_URL}/billing-svc/dlvorders/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.number = response.data.number;
          this.businessPartnersCode = response.data.businessPartnersCode;
          this.ename = response.data.ename;
          this.dcldate = response.data.dcldate;
          this.inbordersNumber = response.data.inbordersNumber;
          this.vesselname = response.data.vesselname;
          this.mawb = response.data.mawb;
          this.hawb = response.data.hawb;
          this.edescription = response.data.edescription;
          this.itemgw = response.data.itemgw;
          this.itempck = response.data.itempck;
          this.packagesCode = response.data.packagesCode;
          this.gwunit = response.data.gwunit;
          this.status = response.data.status;
          this.remark = response.data.remark;
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
